import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import './style.scss';
import { getReportNotificationLabel } from './helpers';


export const ReportGeneratorNotification = ({ selectedReportType }) => {
    const [notificationLabel, setNotificationLabel] = useState('');

    const { t: translate } = useTranslation();

    useEffect(() => {
        setNotificationLabel(getReportNotificationLabel(selectedReportType));
    }, [selectedReportType]);

    return <>
        {notificationLabel &&
            <div><b>{translate('ABB.Powertrain.Frontend.assetOverviewLimitPointTitle')}</b><span className='report__generator__notification'>{translate(notificationLabel)}</span></div>
        }
    </>;
};

ReportGeneratorNotification.propTypes = {
    selectedReportType: PropTypes.object
};

